// Mirrors backend/src/utils/warehouseQuantity.js. Keep commercial precision,
// rounding and public WZ limits aligned across both runtimes.
export const WAREHOUSE_QUANTITY_PRECISION = 3;
export const WAREHOUSE_QUANTITY_MIN = 0.001;
export const WZ_QUANTITY_MAX = 1000000;
export const WZ_QUANTITY_INVALID_CODE = 'WZ_QUANTITY_INVALID';
const WAREHOUSE_QUANTITY_FACTOR = 10 ** WAREHOUSE_QUANTITY_PRECISION;
// Only absorb binary floating-point noise. A commercial fourth decimal must
// never pass validation and then be rounded silently by NUMERIC(14,3).
const WAREHOUSE_QUANTITY_EPSILON = 1e-9;

export function roundWarehouseQuantity(value: unknown): number {
  const quantity = Number(value);
  if (!Number.isFinite(quantity)) return Number.NaN;
  return Math.round((quantity + Number.EPSILON) * WAREHOUSE_QUANTITY_FACTOR)
    / WAREHOUSE_QUANTITY_FACTOR;
}

export function isWarehouseQuantity(value: unknown, min = WAREHOUSE_QUANTITY_MIN): boolean {
  const quantity = Number(value);
  return Number.isFinite(quantity)
    && quantity >= min
    && Math.abs(quantity - roundWarehouseQuantity(quantity)) < WAREHOUSE_QUANTITY_EPSILON;
}
